module.exports = __webpack_public_path__ + "img/contact_join_02.434c0122.png";